module.exports = __webpack_public_path__ + "img/calendar-21_fill.1d5952ad.svg";